module.exports = __webpack_public_path__ + "img/TaskFino-Login-page-old.90c1f6ad.jpg";